// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"cp-z","slideIn":"dp-z"};